import { fetchData } from './micros';

export const GET = (url, data, headers) => fetchData('GET', url, data, headers);
export const POST = (url, data, headers) => fetchData('POST', url, data, headers);
export const PUT = (url, data, headers) => fetchData('PUT', url, data, headers);
export const DELETE = (url, data, headers) => fetchData('DELETE', url, data, headers);
